module.exports = __webpack_public_path__ + "img/feature_a01.3b3d8263.svg";